import * as z from "zod";
import { literal } from "zod";
import { ConfirmCompareProductsSchema } from "../../agents/support-agents/confirm-compare-products";
import { ContentType } from "../../conversation";
import {
  AutoGeneratedFieldsSchema,
  BaseActionableComponentMessageSchema,
} from "../message-parser-utils";

export const ProductComparisonMessageSchema =
  BaseActionableComponentMessageSchema.extend({
    contentType: literal(ContentType.PRODUCT_COMPARISON),
    structuredContent: ConfirmCompareProductsSchema,
  });

export const ProductComparisonMessageDbParser =
  ProductComparisonMessageSchema.merge(AutoGeneratedFieldsSchema);

export type ProductComparisonMessage = z.infer<
  typeof ProductComparisonMessageDbParser
>;
